module.exports = __webpack_public_path__ + "img/mobile-index-text.71368969.png";